import api from '@/helpers/api'
import qs from 'qs'

export default {
  searchObat (data) {
    return api.get('obat/search/' + data)
  },
  getObat (data) {
    return api.get('obat?' + qs.stringify(data))
  },
  getAllObat () {
    return api.get('obat/all')
  },
  getStockObat () {
    return api.get('obat/semua')
  },
  getObatDetail (id) {
    return api.get('/obat/' + id)
  },
  addObat (obat) {
    return api.post('/obat', obat)
  },
  updateObat (id, obat) {
    return api.patch('/obat/' + id, obat)
  },
  deleteObat (id) {
    var data = []
    return api.delete('/obat/' + id, qs.stringify(data))
  }
}
